import { useState,useEffect } from 'react';
import { Navigate, useLocation } from "react-router-dom";
import SetPasswordRender from './children/SetPasswordRender';
import { findPassword } from '@/services/api'

const SetPassword = (props) => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const [linkToSuccessPage, setLinkToSuccessPage] = useState(false); //是否跳转成功页面
    const stateParams = useLocation();

    // console.log(stateParams)

    // 提交表单数据
    const requestSetPassword = async (params) => {
        setSubmitLoading(true)
        params = { ...params, verify_token: stateParams.state?.verify_token }
        console.log(params)
        const { code } = await findPassword(params);
        if (code === 200) {
            setLinkToSuccessPage(true)
        }
        setSubmitLoading(false)
    }

    useEffect(() => {
        document.title = "设置新密码-个人中心";
        document.querySelector('meta[name="keywords"]').setAttribute('content','设置新密码');
        document.querySelector('meta[name="description"]').setAttribute('content','设置新密码');
    })


    return (
        <>
            {linkToSuccessPage && <Navigate to={`/set-success`} state={{title: '新密码设置成功',modelText:'新秘密设置成功，5秒内自动跳转到登录页面。'}} replace={true} />}
            <SetPasswordRender
                submitLoading={submitLoading}
                requestSetPassword={requestSetPassword}
            />
        </>
    );
}

export default SetPassword;
